import { T } from "../../hooks/useTranslate";
import { OrderSummaryCell } from "./OrderSummaryCell";

const formatCommissionMonth = (initialValue) => {
  if (!initialValue) return;

  const arr = initialValue.split("-");
  const year = arr[0];
  const month = arr[1];

  return `${month}/${year}`;
};

const allColumns = [
  {
    headerName: "Order Details",
    headerClassName: "ordersTableHeader",
    sortable: false,
    display: "flex",
    justifyContent: "flex-start",
    width: 165,
    field: "id.unicity",
    headerAlign: "left",
    align: "left",
    renderCell: (params) => <OrderSummaryCell order={params.row} />,
    renderHeader: () => <span data-test-id="order-details-column-header" style={{ fontSize: "calc(10px * var(--unicity-font-scale, 1))" }}><T>order_details</T></span>
  },
  {
    headerName: "Commission Mo.",
    field: "terms.period",
    headerClassName: "ordersTableHeader",
    width: 135,
    sortable: false,
    headerAlign: "right",
    align: "right",
    renderCell: (params) => <span data-test-id={`commission-month-value-${params.row.id.unicity}`} style={{ fontSize: "calc(12px * var(--unicity-font-scale, 1))" }}>{formatCommissionMonth(params.row.terms.period)}</span>,
    renderHeader: () => <span data-test-id="commission-column-header" style={{ fontSize: "calc(10px * var(--unicity-font-scale, 1))" }}><T>commission_month</T></span>
  },
  {
    headerName: "PV",
    width: 50,
    field: "terms.pv",
    headerClassName: "ordersTableHeader",
    sortable: false,
    headerAlign: "right",
    align: "right",
    renderCell: (params) => <span data-test-id={`pv-value-${params.row.id.unicity}`} style={{ fontSize: "calc(12px * var(--unicity-font-scale, 1))" }}>{params.row.fulfillmentStatus === "Cancelled" ? '-' : params.row.terms.pv}</span>,
    renderHeader: () => <span data-test-id="pv-column-header" style={{ fontSize: "calc(10px * var(--unicity-font-scale, 1))" }}><T>pv</T></span>
  },
];

// GO-3036: affiliates do not see the PV column on a customer's order list.
// Pass isAffiliate=true to strip the column; default falsy preserves the
// distributor view.
export const getColumns = (isAffiliate) =>
  isAffiliate ? allColumns.filter((c) => c.field !== "terms.pv") : allColumns;

// Backwards-compat alias for callers that still import { columns }.
export const columns = allColumns;